const ACCESSCODEE = {
  SET_ACCESSCODEE_QUERY: 'SET_ACCESSCODEE_QUERY',
};

export default ACCESSCODEE;
